export default __webpack_public_path__ + "static/media/card12.ae20278b.png";